export default {
  home: '首页',
  'Co-builders': '共建方介绍',
  traceability_search: '数源查询',
  standards_and_specifications: '标准与规范',
  help_center: '帮助中心',
  Consulting: '互动咨询',
  about_us: '关于我们',
  our_mission: '我们的使命',
  more_public_services: '更多公共服务',
  learn_more: '了解更多',
  query: '立即查询',
  query2: '立即搜索',
  publish_service: '我要发布服务',
  Response_a_requirement: '我要响应需求',
  service_info: '需求发起信息',
  valid_time: '有效时间',
  req_msg: '需求信息',
  res_person: '我要需求响应',
  show_power: '服务能力展示',
  service_valid: '服务时效',
  contact_man: '联系人',
  contact_method: '联系方式',
  Contact_email: '联系邮箱',
  contact_address: '联系地址',
  publish_req: '我要发布需求',
  grid_pagination: {
    participate: '参与数源，获取数据',
    safeguard: '维权',
    case: '案例',
    join: '加入数源',
  },
  view_details: '查看详情',
  human_rights_cases: '维权案例',
  person: '用户中心',
  join_in: '立即加入',
  login: '登录',
  exit: '退出登录',
  is_enterprise: '您不是企业身份',
  ok: '好的',
  feedback: '反馈',
  common_service: '公共服务',
  look_more: '查看更多',
  week: '周',
  month: '月',
  quarter: '季',
  year: '年',
  day: '日',
  Demand_Service_Release: '需求/服务发布',
  Consumer_Center: '消费者中心',
  Global_Traceability_Center_Public_Service_Platform: '全球数源中心公共服务',
  Global_Traceability_Center_Public_Service_Platform_2: '全球数源中心公共服务平台',
  Public_Service_Platform_for_Verification_and_Examination: '检验检测公共服务平台',
  Public_Service_Platform_for_Intellectual_Property_Protection: '知识产权保护公共服务平台',
  Public_Service_Platform_for_Consumer_Rights_Protection: '消费者权益保护公共服务平台',
  Public_Service_Platform_for_Traceability_Industry: '数源产业公共服务平台',
  Global_Traceability_Center1: '中共广州南沙经济技术开发区工作委员会政策研究和创新办公室',
  Global_Traceability_Center: '全球数源中心',
  Infrastructure_for_the_digital_economy: '数字经济基础设施',
  'Efficient_and_low-cost_digital': '高效低成本的数字资产管理工具',
  Public_Infrastructure_for_the_Digital_Economy: '数字经济公共基础设施',
  Covered_Cities: '覆盖城市',
  Data_Assets: '数据资产',
  Consumer_Search: '消费者查询',
  'Multi-party_Participation': '多方参与',
  'Co-construction_and_Mutual_Benefit': '共建共赢',
  Enterprises: '企业',
  Local_Governments: '地方政府',
  Regulatory_Authorities: '监管部门',
  Service_Provider: '服务商',
  Open_Application: '开放应用',
  Consumers: '消费者',
  Service_Process: '服务流程',
  Intellectual_Property_Protection: '知识产权保护',
  Consumer_Rights_Protection: '消费者权益保护',
  Join_Traceability: '参与数源',
  Verification_and_Examination: '检验检测',
  Promote_brands_and_build_a_traceability_ecosystem: '搭建数源生态，触达消费终端 &开展品牌宣传，管理数据资产',
  The_Global_Traceability_Center_is_a_set_of_efficient:
    '全球数源中心汇聚消费者、企业、服务商等多方主体，助力企业宣传，&提升品牌价值，实现数据增值。',
  Identify_the_true_value_of_products: '发现商品真实价值，维护消费权益',
  Enterprises_regulatory_authorities: '企业、监管部门、第三方机构等参与数源共建，传递商品真实价值，共同保障消费者权益。',
  Equip_local_governments: '为地方政府提供区域数字治理工具，促进区域产业&集聚与数字产业发展',
  digital_governance_and_industrial_digitization:
    '全球数源中心服务于区域数字治理和产业数字化，提升数字治理能力，实现共建共享共治，服&务于货物流通、贸易便利、权益维护，推动形成全球商品真实价值传递的国际贸易新生态。',
  information_collected_from_the_whole_commodity:
    '基于商品全生命周期信息，创新数字治理与风险研判&打造源头可溯、风险可控、责任可究的监管模式',
  'Multi-dimensional_risk': '“微观主体+宏观行业”的多维度风险识别保障&“全产业链+生态化”数据监测基础&“数源+辅助监管”的创新模式',
  Gather_various_enterprises: '汇聚大量企业，开拓发展服务市场',
  delivery_of_true_information_about_global:
    '全球数源中心构建全球商品真实价值传递的产业生态体系。&汇聚大量企业参与共建，为各类数源服务商带来海量服务产品机遇。',
  Create_a_variety_of_demand_scenarios: '形成多种需求场景，开拓发展应用市场',
  application_of_new_technologies: '基于数源开放应用，促进新技术、新场景应用，为数字企业发展全新赋能。',
  'Data_Co-construction_Sponsor': '数据共建方',
  'Service_Co-builders': '服务共建方',
  'Integration_co-builders': '协同共建方',
  Traceability_Ecosystem: '数源生态',
  Assist_enterprises_in_building_a_digital: '助力企业搭建数字生态，及时掌握相关共建方动态和风险提示信息',
  'Co-builder_updates': '共建方动态',
  'Co-builder_analysis': '共建方分析',
  Commodity_Ranking: '商品榜单',
  Feedback_Progress: '反馈进度',
  Organizations_that_are_public_in_nature_or_have_won: '负责区域或行业的全球数源中心建设和运营，具有公信力的公共机构或组织。',
  Administrative_Penalty_Announcements: '行政处罚公示',
  My_service_provider_updates: '服务商动态',
  Goods_source_analysis: '商品来源分析',
  Commodity_category_analysis: '商品品类分析',
  Ecological_risk_updates: '风险提示信息',
  Use_Now: '立即使用',
  Data_Asset_Management: '数据资产管理',
  value_of_data_assets: '高效便捷的数字资产管理工具，助力企业挖掘数据资产价值',
  Traceability_Application: '数源应用',
  public_service_functions: '为企业提供多样化的服务资源和开放应用',
  Traceability_data_released: '数据发布',
  Data_search: '数据查询',
  Brand_management: '品牌管理',
  Application_operation: '应用操作',
  Risk_management: '风险管理',
  Feed_back_on_product_quality_and_consumption: '有效反馈商品质量和消费体验',
  Rights_Protection: '权益维护',
  protect_consumer_rights: '协同政府部门、企业共同保障消费者权益',
  Information_Notification: '信息提示',
  'Acquire_real-time_and_dynamic_updates': '实时获取反馈动态信息、风险预警信息',
  Data_Management: '数据分析',
  Manage_traceability_data_and_promote: '通过数源数据分析，助力区域数据治理',
  Rights_Protection_Monitoring: '维权监督',
  Monitor_the_feedback_of_consumers: '全程监督消费者反馈、企业处理情况，实时掌握消费者维权动态',
  Administrative_punishment: '企业处理监督',
  Report_handling: '举报处理',
  Consumer_feedback_query: '消费者反馈查询',
  'Efficient_and_low-cost_risk': '为数字时代提供的一套高效低成本的风险管理工具',
  Risk_tools: '风险工具',
  Risk_early_warnings: '风险预警',
  Risk_releases: '风险发布',
  Acquire_real_product_value_conveniently: '便捷获取商品真实价值',
  Product_Management: '产品管理',
  Manage_your_service_offerings: '管理您的服务产品，向大众全面展现您的服务能力',
  Market_Management: '市场管理',
  Properly_manage_the_service_demands: '妥善管理发布给您的服务需求，助您洞察更多市场机遇',
  Customer_Management: '客户管理',
  Manage_your_customer_information: '管理您的客户信息，助您更好的维护客户关系',
  Service_Management: '服务管理',
  Properly_manage_your_orders_of_service: '妥善管理您的服务委托订单，助您更好的服务客户',
  Risk_Information_Notification: '风险信息提示',
  'Send_you-real-time-traceability': '为企业发送实时风险信息提示',
  Customer_feedback_for_overdue_tips: '消费者反馈逾期未处理提示',
  Intellectual_property_information_tips: '知识产权信息提示',
  Product_list: '产品列表',
  Service_release: '服务发布',
  Demand_market: '需求市场',
  Customer_list: '客户列表',
  Customer_analysis: '客户分析',
  Service_entrustments: '我收到的服务委托',
  Service_feedback_search: '服务反馈查询',
  Application_Management: '应用管理',
  Provide_you_with_traceability: '管理您的协同应用，快速响应订阅需求',
  Order_Management: '订单管理',
  Properly_manage_your_orders: '妥善管理发布给您的应用服务需求，助您洞察更多市场机遇',
  'Send_you_real-time_traceability': '为您发送数源实时风险消息',
  App_launch: '应用上架',
  Collaborative_application_release: '协同应用发布',
  Collaborative_Service_Management: '协同服务管理',
  Demand_management: '需求管理',
  Partnership_management: '合作关系管理',
  'Co-construction_Ecosystem': '共建生态',
  organizations: '家',
  Scope_of_the_Global_Traceability_System: '全球数源体系共建范围',
  intellectualServ: '知识产权服务',
  Traceability_Information: '数源资讯',
  'All-Traceability_Information': '全部资讯',
  Traceability_Application_Cases: '数源应用案例',
  Traceability_Application_Cases_Details: '数源应用案例详情',
  Public_Services_for_Verification_and_Examination: '检验检测公共服务',
  Public_Services_for_Intellectual_Property_Protection: '知识产权保护公共服务',
  Public_Services_for_Consumer_Rights_Protection: '消费者权益保护公共服务',
  Public_Services_for_Traceability_Industry: '数源产业公共服务',
  Let_your_certificate_speak: '让证书会说话、广流通',
  One_click_access_to_global: '一键对接全球企业和一流检验检测机构',
  A_constellation_of_top_service_providers: '汇聚一流服务商',
  'One-stop_intellectual_property': '提供完善的咨询、申请、维权一站式知识产权服务',
  A_collection_of_global: '汇聚全球知识产权信息',
  Providing_a_comprehensive: '提供知识产权登记、转让、许可等用权综合平台。',
  'merchandise-centered_consumer_rights_protection':
    '全球数源中心汇集以商品为核心的全渠道消费者权益保护信息，形成消费者、企业、政府部门等多方参与的全新的消费者权益保护机制，让维权更放心。',
  'Every_co-builder_is_a_groundbreaker': '每一位共建方都是数源产业的开创者、建设者、获益者',
  Quick_links_to_industry: '快速链接产业供需',
  Quick_exploration_in_the_business: '快速挖掘产业应用',
  Quick_Visit: '快速访问',
  Service_Mailbox: '服务邮箱',
  Follow_Us: '关注我们',
  SHUYUAN_Mini_Program: '数源小程序',
  Global_Service_Hotline: '全球服务热线',
  Quick_participation_in_industry: '快速参与产业共建',
  Organizations_or_individuals: '在全球数源体系内提供商品数源数据的组织或个人，拥有其提供的数源数据的所有权。',
  Organizations_that_provide_coverage: '为实现全球数源体系信息有效、准确、便利传递，',
  More: '更多',
  traceability_informatization_or_broaden: '为优化全球数源信息化建设提供技术支持，或按其他共建方需求拓展数源在产业中应用的机构或组织。',
  'Supporting_Co-builders': '支撑共建方',
  traceability_level: '数源等级',
  Traceability_Services: '数源服务',
  FAQs: '常见问题',
  all: '全部',
  Traceability_Development_History: '全球数源中心发展历程及荣誉',
  Multi_party_Participation: '多方参与 共建共赢',
  Comprehensive_intelligent_and_efficient: '全面、智能、高效',
  One_click_access_demands: '全球检测需求一键获取',
  Fully_aware_of_certificates_reports:
    '证书/报告全面知悉，有效打击假冒仿造&打破环节服务的桎梏，实现证书/报告广域流通&提升检验检测机构品牌价值',
  Easy_to_use: '易用、可靠、有效',
  One_click_access_to_institutions: '一键获取全球检测机构全方位服务',
  Certificate_report_multi_party: '证书/报告多方核验背书&减少风险，更加可信、可用',
  Certificate_Application: '证书应用情况',
  Learn_about_the_circulation: '获知证书流通应用情况，助力全面打击假冒证书',
  Certificate_verification: '证书核验',
  Application: '应用情况',
  Service_Market: '服务市场',
  Search_service_market: '查看检验检测服务市场信息，助您找到优质服务',
  Service_providers_search: '服务商查询',
  Service_items_search: '服务项目查询',
  One_stop_management: '一站式管理和跟踪您发布的检验检测需求',
  Demand_release: '需求发布',
  Service_entrustment: '服务委托',
  You_can_initiate_service: '您可发起服务委托，进行检验检测业务办理',
  Service_feedback: '服务反馈',
  Serve_the_World: '服务全球',
  Latest_Released_Demands: '最新发布的需求',
  Latest_Released_Services: '最新发布的服务',
  traceability_industry:
    '全球数源中心打造了检验检测服务、知识产权保护、消费者权益保护、数源产业服务等多个公共服务平台，为共建方提供丰富的公共服务，为数字经济发展提供助力。',
  went_live_online:
    '<p>1.0版本上线</p>全球数源体系1.0版本，作为质量管理工具，在南沙自贸区正式上线。<p>2015年11月</p>全球数源体系应用实例“跨境电商监管新模式”入选全国自由贸易试验区最佳实践案例。',
  'Global_Traceability_System_Version_2.0_was_released': '全球数源体系应用实例“跨境电商监管新模式”入选商务部最佳实践案例。',
  'Global_Traceability_Version_3.0_was_released':
    '<p>2.0版本上线</p>开发了“一平台、三系统”数源运行架构，实现对不同用户不同维度数源信息的采集、应用和服务。',
  Customs_Global_Quality_Traceability:
    '<p>3.0版本上线</p>基于公共基础设施理念，形成区块链和去中心化的分布式架构，实现了公共基础设施与不同行业和领域数源应用的分离。',
  coordinated_development:
    '<p>打造4.0版本</p>以数字经济公共基础设施为定位，建设一套数源公共技术，构建标准体系，探索法律保护体系，建设数源实体中心，支持全球各地快速复制推广、互联互通。<p>2019年9月</p>全球数源中心入选2019“新华信用杯”全国信用典型案例。',
  The_first_Global_Traceability_Center_went_live:
    '<p>2020年10月</p>依托全球数源体系打造的“基于多方安全计算数源认证的跨境结算服务”纳入中国人民银行广州分行广州金融科技创新监管试点应用，成为“数源+金融”开放新应用。<p>2020年11月</p>与海南自由贸易港洋浦经济开发区签订协同发展战略合作框架协议，包括共建全球数源中心创新优势，打造港湾联动先行示范区。',
  Committee_of_the_Guangzhou:
    '<p>2021年3月</p>与山东自贸试验区青岛片区签署全球数源中心共建战略合作协议，共同打造数字贸易创新发展新生态。<p>2021年4月</p>构建全球数源体系标准体系入选广东自贸试验区六周年制度创新最佳案例。<p>2021年6月</p>全球数源服务标准化试点获批国家标准化管理委员会第七批社会管理和公共服务综合标准化试点项目。<p>2021年10月</p>首次发布《全球数源体系共建方通则》、《全球数源体系服务通则》等8份全球数源体系标准，采用标准化手段全面复制推广全球数源体系和推动全球数源中心建设运营。',
  time_line_2022:
    '<p>2022年1月</p>广东省地方标准《商品全生命周期数源通用要求》正式发布，推进南沙首创的全球数源体系从理论到标准化转型，形成全球数源体系推广应用规则和指南。<p>2022年3月</p>全球数源中心获评粤港澳大湾区数字治理优秀案例。<p>2022年4月</p>与国家市场监督管理总局信息中心签订《全球数源中心战略合作备忘录》，开展全球数源体系的深度战略合作，共同打造南沙市场监管数源辅助应用的先行示范。<br/>与中国交通建设集团有限公司签署《全球数源体系暨全球数源中心项目全面战略合作协议》，共同推动全球数源中心全球化布局，共同打造数源产业研发创新平台。<p>2022年9月</p>与福建自贸试验区厦门片区签署协同高质量发展战略合作框架协议，包括共建全球数源中心创新优势，共同探索进出口商品安全管理全球范例。<p>2022年10月</p>全球数源中心获评全国社会治理创新案例。<p>2022年11月</p>全球数源中心数字经济与数据制度建设的探索与实践入选中国管理年度价值案例。<p>2022年12月</p>全球数源中心获评第八届中国管理科学奖。<br/>全球数源体系6项标准入选粤港澳大湾区共通执行标准。',
  time_line_2023:
    '<p>2023年3月</p>全球数源中心入选国务院全面深化服务贸易创新发展试点第三批“最佳实践案例”。<br>全球数源中心获批广东省信用应用创新“揭榜挂帅”行动计划项目。<p>2023年5月</p>出版《风起南沙：全球数源中心标准体系》、《全球数源中心——数字经济时代的南沙方案》<p>2023年6月</p>全球数源体系4.0版本正式上线',
  Global_Traceability_System_standards_and_specifications_file: '全球数源体系标准与规范文件',
  Display_the_demands_released: '展示企业发布的需求和入驻服务商提供的服务能力',
  Demand_List: '需求一览',
  Service_List: '服务一览',
  Enter_the_enterprise_you_want_to_find: '请输入您想查询的发布企业',
  Enterprise: '发布企业',
  Title: '需求标题',
  Type: '需求类型',
  Industry: '服务行业',
  req_Description: '需求描述',
  Released_time: '发布时间',
  service_Accessories: '服务附件',
  service_item_information: '服务项目信息',
  service_information: '服务信息',
  Enter_the_service_provider_you_want_to_find: '请输入服务商名称查询',
  Service_provider: '发布服务商',
  Range: '服务范围',
  Partner_Service_Providers: '服务商概览',
  Service_area: '服务地域',
  no_more: '没有更多了',
  Notarization: '公证机构',
  Verification: '检验检测机构',
  Certification: '认证机构',
  Traceability: '数源标识服务商',
  'Service_co-builders_include': '按其他共建方需求提供服务的机构或组织。',
  Gather_first_class_service:
    '汇聚一流服务商，提供完善的咨询、申请、维权一站式知识产权服务&汇聚全球知识产权信息，提供知识产权登记、转让、许可等用权综合平台',
  Global_configuration_and_innovative: '全球布局，创新产品服务模式',
  Provide_intellectual_property_service_providers:
    '为知识产权服务商提供知识产权供需市场新蓝海;&为企业提供知识产权登记、转让、许可等用权新平台;&为企业提供咨询、代理、维权一体化综合服务新路径;&为企业提供全品类知识产权信息提示新方案。',
  Intelligent_reminder_for_Intellectual_property_risk: '知识产权风险智能提示，便捷获取咨询&服务',
  Gather_a_globally_massive_amount_of_commodity:
    '汇聚全球海量商品知识产权信息，助力您高效、便捷识别知识产权侵权风险；&汇聚全球海量知识产权服务商，为您提供专业的知识产权咨询、申请及维权服务；&汇聚全球海量企业，为您提供知识产权转让、许可使用商机蓝海。',
  Intellectual_property_registration: '知识产权登记',
  Register_intellectual_property_and_effectively: '登记知识产权信息，有效识别知识产权侵权风险',
  Intellectual_Property_Management: '知识产权管理',
  Brand_Information_Management: '品牌信息管理',
  Goods_Query: '商品查询',
  Information_Push: '信息推送',
  Receive_information_of_intellectual_property: '接收全球数源中心的推送与企业主体、商品关联的涉及知识产权的信息',
  Search_intellectual_property: '查看知识产权服务市场信息，助您找到优质服务',
  One_stop_management_and_tracking: '一站式管理和跟踪您发布的知识产权需求',
  You_can_initiate_a_service: '您可发起服务委托，进行知识产权服务办理',
  help_you: '帮助您',
  find_the_true_value_of_commodities: '发现商品真实价值',
  'provides_an_efficient_and_cost-effective': '全球数源中心为数字时代的商品数据采集、识别和处置提供了一套高效低成本的工具',
  more_traceability_information: '了解更多数源信息',
  Traceability_ID: '数源标识',
  Order_number: '订单号',
  VIN_number: 'VIN号',
  Tracking_number: '运单号',
  Traceability_Search_Service_Guide: '数源查询服务指南',
  Consumers_visit_the_Global_Traceability_1: '消费者在全球数源中心注册个人账户',
  Consumers_search_product_traceability_1: '消费者扫描数源标识，查询商品数源数据',
  Consumers_search_product_traceability_2: '',
  Consumer_Feedback: '消费者反馈',
  Consumers_can_ask_for_consultation_1: '消费者参与反馈商品价值信息，',
  Consumers_can_ask_for_consultation_2: '相关企业参与处理',
  Legal_liabilities: '法律追责',
  The_consumer_can_request: '若购买的商品在全球数源中心法律追责范围内，消费者可共同参与法律追责，维护自身权益',
  Mobile_Search_Tools: '移动端查询工具',
  Global_Traceability_Center_portable: '全球数源中心掌上服务系统，支持消费者扫码数源，获取商品真实价值信息',
  SHUYUAN_APP: '数源App',
  Scan_QR_code_to_open_WeChat_or_Alipay_for_traceability_via_QR_code: '打开微信、支付宝“全球数源查询服务平台”小程序即可扫码数源',
  SHUYUAN_WeChat_Official_Account: '数源微信公众号',
  open_the_WeChat_Official_Account: '关注“全球数源中心”微信公众号，了解更多数源信息',
  trace: '数源',
  industry: '产业',
  Expand_the_horizon: '扩展服务领域，提高品牌知名度',
  The_Global_Traceability_Center_integrates: '全球数源中心汇聚多类行业，拓展服务应用，提升业务范围，提高品牌知名度，扩展服务商业发展空间。',
  Facilitate_digitization: '助力企业数字化，激发企业驱动力',
  The_Global_Traceability_Center: '全球数源中心聚集全链条产业服务，降本增效，助力企业数字化。拓展产业应用，激发企业内生驱动力。',
  Traceability_industry_service: '数源产业服务',
  Risk_early_warnings_Mess: '风险预警信息',
  Search_service_market_information: '查看数源产业服务市场信息，助您找到优质服务',
  Application_Market: '应用市场',
  Search_market_information: '查看开放应用市场信息，助您找到优质服务应用',
  Demand_and_Service_Releases: '数源产业需求与服务发布',
  Participating_Service_Providers: '已参与的服务商',
  recommend: '推荐',
  enterprise_department: '政府部门',
  Discover_the_true_value: '发现商品真实价值，维护合法权益',
  consumers_can_conveniently_acquire_information:
    '借助数源，消费者可便捷获取商品真实价值信息，在满足知情权的同时，还可真实反馈和表达对商品的看法，主动参与商品的价值信息共享，更为高效地维护自己的合法权益。',
  Identify_consumers: '洞察消费者实际需求，优化产品质量',
  enterprises_can_acquire_product:
    '借助数源，企业可便捷获取全渠道商品消费信息，直接聆听消费者真实声音，快速响应消费者反馈，基于用户体验优化产品质量和改进生产经营方式。',
  Information_fence_and_risk_assessment: '信息围网，风险研判',
  government_departments_are_able_to_acquire:
    '借助数源，政府部门可便捷获取商品全链条价值信息，实现监管的前伸后延，做出更精准的监管决策，形成事前、事中、事后全链条低成本监管，进一步提升监管效能。',
  Dealing_with_Consumer_Feedback: '参与处理消费反馈',
  Quickly_respond_to_consumer: '快速响应消费者反馈，与全球消费者实时互动',
  Statistical_analysis: '统计分析',
  Actualize_data_visualization: '消费者反馈数据可视化，助力提升企业响应效率',
  'Full-process_Monitoring_of_Consumer_Feedback': '消费者反馈全流程监督',
  Monitor_consumer_feedback: '全程监督消费者反馈、企业处理情况，实时掌握反馈动态',
  Assist_the_regulatory_authorities: '消费者声音可视化，维权数据可视化',
  Enterprise_profile: '企业简介',
  provides_you_with_information: '借助数源，您可知悉商品在生产、贸易、流通、消费的全生命周期过程中产生的信息。',
  Protection_of_Rights_and_Interests: '权益保护',
  applicable_regulatory_requirements:
    '全球数源中心向数据共建方共享商品的质量信息、贸易信息、监管应用信息、消费者反馈信息等商品真实价值信息，形成消费者、企业、政府部门商品价值传递的良性互动和闭环设计。同时由地方政府主导，监管部门共同参与，企业落实跟进，协同处理消费者反馈，共同保障消费者权益。',
  investigate_the_enterprise: '企业因虚假声明造成消费者权益损害时，公证法律服务机构作为受害消费者代理人对企业进行法律追责。',
  Consumer_Service_Guide: '消费者服务指南',
  no_data: '暂无数据',
  no_content: '暂无内容',
  no_relevant_content_was_found: '很抱歉，暂时没有查到相关内容',
  one_trace: '一键数源',
  loading: '拼命加载中',
  Properly_manage_your_orders_of_application: '妥善管理您的应用服务委托订单，助您更好的服务客户',
  More_industries_await_your_participation: '更多产业期待您的加入',
  Hosted_by: '主办单位名称',
  Guangzhou_Nansha_Economic_and_Technological: '全球数源中心（广州南沙）有限公司',
  AI_service: '智能客服',
  AI_traceability: '数源介绍',
  total: '共',
  page: '页',
  skip_to_page: '跳转至第',
  confirm: '确定',
  The_basic_information: '基本信息',
  Spec: '规格',
  Brand: '品牌',
  Batch: '生产批次号',
  Guangdong_ICP: '粤ICP备2025470256号-2',
  Service_Provider_Information: '服务商信息',
  Comprehensive_Services: '综合服务',
  Publicity_Information: '宣传信息',
  Top_searches: '大家都在搜',
  I_want_to_find_reliable_traceability_apps: '我想找到更全面靠谱的数源应用',
  my_agency_test: '我想了解我的机构的检测报告被用在哪里',
  I_want_more_traceability_services: '我想寻求更多的数源产业服务',
  quality_of_my_purchase: '我想知道,我买的东西质量如何',
  my_products_been_plagiarized: '我想知道我司产品是否被山寨',
  You_might_want_to_search: '猜你想搜',
  How_to_join_traceability: '怎么加入数源',
  find_IP_protection_service: '我怎么能找到知识产权保护服务商',
  standard_traceability_services: '数源产业有哪些典型的场景式服务',
  post_testing_demands: '我想发布检验检测需求',
  authentic_product_data: '消费者怎么查询商品的真实数据',
  Ask_Online: '在线咨询',
  FAQs_copyRight_Global_Traceability_Center: '常见问题版权所有©全球数源中心',
  origin_of_goods: '商品产地',
  Service_location_request: '服务地点/要求',
  Article_Details: '文章详情',
  traceability_updates_in_real_time: '数源动态展示,实时信息更新',
  more_plat: '更多平台',
  about_title_2: '全球数源中心四大创新',
  about_content_2:
    '作为全球数源体系的落地载体，全球数源中心形成了一系列集成创新成果。一是规则创新。构建商品数据化的规则，搭建标准体系，发布省地方标准，获批国标委社会管理与公共服务标准化试点，探索数据流通、权益保护分配等法律保护体系。二是技术创新。形成了第三方专业机构、监管部门等多维数据核验，并以公共技术支持复制推广及开放应用。三是工具创新。打造海关、市场监管、“信易+”数源辅助管理工具，“数源+跨境结算”成为广州首批金融创新试点。四是产业创新。搭建消费者权益等四大公共服务，吸引数源标识、知识产权、检验检测等产业服务集聚，探索“数源+二手车出口”、“数源+口岸物流”等模式。',
  about1_content:
    '全球数源中心是地方政府主导、监管部门共建共用、社会组织共同参与，以“共建共享、真实安全、开放便利”为基本原则，面向全球政府、企业、消费者平等开放的去中心化的数字经济公共基础设施。全球数源中心通过对商品全生命周期数据进行分段采集、分级使用，建立规则标准、法律权责的行为共识，以数字合约的技术手段，将商品信息转化为数据生产资料，实现高效低成本信息共享，服务于区域数字治理、产业数字化、数字产业化，促进货物流通、贸易便利、权益维护，为新时代全球数字治理提供新方案。\n       全球数源体系是各国政府部门、企业和消费者共建共享的价值传递体系。通过对商品生产、流通、分配和消费全生命周期的数据采集、科学分析与精准识别，实现风险可识别、可控制、可处置，服务于货物流通、贸易便利、权益维护，以最低成本实现商品价值的真实传递。全球数源体系是由广州南沙全自主知识产权打造的制度创新成果，属全国首创。',
  NanSha_Center: '全球数源中心（南沙）',
  NanSha_Center_Title: '中国（广东）自由贸易试验区广州南沙新区片区管理委员会',
  NanSha_Center_Title_1: '广州南沙经济技术开发区管理委员会',
  NanSha_Center_Content_1:
    '广州南沙地处粤港澳大湾区地理几何中心，距香港38海里、澳门41海里，面积803平方公里，承载着广东省唯一的国家级新区、广东自贸试验区面积最大的片区、粤港澳全面合作示范区等战略使命。2022年6月，国家出台《广州南沙深化面向世界的粤港澳全面合作总体方案》，明确把南沙打造成为立足湾区、协同港澳、面向世界的重大战略性平台。',
  Co_founder_of_global: '全球数源体系共建方',
  Co_founder_of_global_tips:
    '自愿加入全球数源体系，秉持“共建共享、真实安全、开放便利”的基本原则，在商品全生命周期价值传递过程中，提供数据或服务的组织或个人。',
  Co_founder_of_global_tips2: '全球数源体系共建方按其功能可分为：数据共建方、服务共建方、协同共建方和支撑共建方。',
  intellectual_property_consulting: '知识产权咨询',
  intellectual_property_agency: '知识产权代理',
  intellectual_property_rights_protection: '知识产权维权',
  detection_requirements: '检测需求',
  test_requirements: '检验需求',
  authentication_requirements: '认证需求',
  identify_equipment_requirements: '标识设备需求',
  identity_generation_requirements: '标识生成需求',
  logo_production_requirements: '标识制作需求',
  identify_related_requirements: '标识关联需求',
  identification_information_collection_requirements: '标识信息采集需求',
  self_declaration_notarization_service: '声明公证服务',
  inspection_service: '检验服务',
  authentication_service: '认证服务',
  Suggest_using_resolution: '建议使用1920*1080分辨率',
  detection_service: '检测服务',
  identity_generation_service: '标识生成服务',
  logo_making_service: '标识制作服务',
  identifies_the_associated_service: '标识关联服务',
  identification_information_collection_service: '标识信息采集服务',
  identify_device_service: '标识设备服务',
  service_items: '服务项目',
  service_items_description: '服务项目说明',
  common_keywords: '常用关键词',
  please_enter_search_keywords: '请输入搜索关键词',
  scan_code_and_download: '下载“SHUYUAN”App即可扫码数源',
  please_select: '请选择',
  input_query_traceability_results: '输入{arg}查询数源结果',
  applet: '小程序',
  official_account: '公众号',
  Achieving_optimal_results: '达到最佳效果',
  factory_level_traceability_brief_introduction: '工厂级数源：由品牌商或生产商在商品生产源头发起的数源。',
  trader_level_traceability_brief_introduction: '贸易商级数源：由贸易商在商品贸易流通过程发起的数源。',
  port_level_traceability_brief_introduction: '口岸级数源：由贸易商在商品出入境环节发起的数源。',
  factory_level_traceability: '工厂级数源',
  trader_level_traceability: '贸易商级数源',
  port_level_traceability: '口岸级数源',
  principal_attribute: '主体属性',
  three_level_traceability: '三级数源',
  provide_strategies: '为各类共建方提供在典型场景下加入、办理、应用数源的攻略',
  product_data_attribute: '商品数据属性',
  join_the_global_traceability: '加入全球数源体系,成为数源共建方。',
  registered_brand_or_manufacturer: '登记身份为品牌商或生产商',
  possess_the_main_body_capacity: '拥有主体能力证明文件。如验厂报告等',
  registered_as_a_trader: '登记身份为贸易商、品牌商或生产商。',
  brand_or_manufacturer_releases_goods: '品牌商或生产商发布商品潴源数据中同时满足',
  it_must_include_production_information: '必须包括生产信息，且能通过"品牌商或生产商 + 工厂名称"关联其主体能力证明文件。',
  it_must_include_commodity_quality_information: '必须包括商品质量信息附件，如各类检测证书/报告、各类产品认证证书等。',
  it_must_include_logistics_information: '必须包括物流信息附件，如装载单、发货单、运单等。',
  traders_brands_or_manufacturers: '贸易商、品牌商或生产商发布商品数源数据中同时满足',
  it_does_not_have_the_certification: '不具备主体能力证明文件，同时不具备商品质量信息附件。',
  the_logistics_information_includes: '物流信息包括从哪来(如来源国别/地区)、到哪去(如目的国别/地区)。',
  platform_services: '平台服务',
  high_quality_cases: '各企业在数源产业平台中成功进行商业合作的优质案例，数源为企业良性发展提供更智能、更广阔的蓝海空间',
  scenario_based: '场景式',
  service: '服务',
  focus_on_providing_more_effective: '聚焦为数源共建方提供更有效、准确、便利的服务，延伸数源产业链。',
  tracing_notarization_industry_service: '数源公证产业服务',
  focus_on_the_open_application: '聚焦数源开放应用，拓展数源在新技术、新场景的应用，促进数源与相关产业融合发展。',
  traceability_open_application: '数源开放应用',
  other_services: '其他服务',
  service_period: '服务周期',
  search_no: '您输入的查询条件不符合规范',
  no_query_criteria: '你没有输入查询条件哦~',
  Role_Prohibition: '当前角色禁止查看更多信息',
  Support_Co_construction_Sponsors: '支撑共建方：',
  Traceability_activities: '数源活动',
  exhibitionHall_Text:
    '全球数源中心实体中心位于南沙蕉门河西畔的融通大厦6楼，内设展示体验区、应用推广区、公共服务区等。全球数源中心展厅借鉴了国际木质流线型空间的表现手法，以木的亲和与沉稳体现数源共识、共享、共建、共赢的本质特征。全球数源中心现已开通展厅参观、公开课培训等数源活动线上预约通道，面向全球政府、企业、消费者免费开放，欢迎扫码了解活动详情。',
  financial_credit_demand: '金融信贷需求',
  other_financial_needs: '金融其他需求',
  financial_credit_services: '金融信贷服务',
  other_financial_services: '金融其他服务',
  Enterprise_Information: '企业信息',
  Contact_number: '联系电话',
  enterprise_mailbox: '企业邮箱',
  Company_address: '企业地址',
  Promotional_images_and_videos: '宣传图片和视频',
  qualifications_1: '资质',
  Service_Price: '服务价格',
  Service_efficiency: '服务效率',
  Service_quality: '服务品质',
  Service_Attitude: '服务态度',
  demand_category: '需求类目',
  Feedback_enterprise: '反馈企业',
  Feedback_time: '反馈时间',
  Feedback_description: '反馈描述',
  Face_to_face_discussion: '面议',
  Asia: '亚洲',
  China: '中国',
  Korea: '韩国',
  Cambodia: '柬埔寨',
  Malaysia: '马来西亚',
  Thailand: '泰国',
  Japan: '日本',
  Singapore: '新加坡',
  Vietnam: '越南',
  Europe: '欧洲',
  Poland: '波兰',
  Germany: '德国',
  Denmark: '丹麦',
  France: '法国',
  Finland: '芬兰',
  Netherlands: '荷兰',
  Sweden: '瑞典',
  Spain: '西班牙',
  Britain: '英国',
  Italy: '意大利',
  North_America: '北美洲',
  America: '美国',
  Canada: '加拿大',
  Oceania: '大洋洲',
  Australia: '澳大利亚',
  New_Zealand: '新西兰',
  Samoa: '萨摩亚',
  Add_to_favorites: '加入收藏',
  Initiate_cooperation_registration: '发起合作登记',
  View_More_Information: '查看更多信息',
  Service_category: '服务类目',
  Traceability_industry: '数源产业',
  tips_001: '您当前非服务共建方，无法进行需求响应',
  tips_002: '您当前非数源共建方，无法发布需求',
  tips_003: '您当前非服务共建方，无法发布服务',
  tips_004: '您的企业暂不具备响应此需求的服务资质能力要求，请先去完善相应的资质能力。',
}
